<script>
    export default {
        props: {
            value: {
                type: Array,
                default: null
            },
            classes: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                packages: this.value,
            }
        },
        mounted() {
            this.$root.$on('deletedPackage', (id) => {
                this.packages = _.filter(this.packages, function (p) {
                    return p.id !== id;
                });
            });
        },
        methods: {
            updateDate() {
                this.$emit('input', {
                    value: this.packages
                })
            }
        },
    }
</script>
<template>
    <div id="packages">
        <div v-if="!packages.length" class="col-lg-12" v-cloak>
            <slot name="no-packages"></slot>
        </div>

        <div v-for="(packageModel, idx) in packages" :class="idx % 2 ? 'row' : ''">
            <div :class="classes">
                <component
                        v-model="packages[idx]"
                        :key="packageModel.id"
                        :is="packageModel.package_view_component_name"
                ></component>
            </div>
        </div>

        <div v-if="packages.length > 2" class="col-lg-12" v-cloak>
            <slot name="more-packages"></slot>
        </div>
    </div>
</template>
